/* ==========================================================================
   Mondō London — product gallery
   One large main image + a thumbnail strip. Click a thumb to swap the main;
   serif arrows either side step through with wrap-around.
   ========================================================================== */
(function () {
  'use strict';

  function thumbs() { return Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]')); }

  var swapToken = 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // overlay layer for dissolves: the new image fades in OVER the old one,
  // so the photograph never dips toward the background mid-swap
  function xfadeLayer(main) {
    var layer = main.parentElement.querySelector('.gallery-xfade');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'gallery-xfade';
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('alt', '');
      main.parentElement.appendChild(layer);
    }
    return layer;
  }

  function show(t) {
    var main = document.querySelector('[data-gallery-main]');
    if (!main || !t) return;
    thumbs().forEach(function (x) { x.classList.toggle('is-active', x === t); });
    var full = t.getAttribute('data-full');
    var alt = t.getAttribute('data-alt');
    if (!full || main.getAttribute('src') === full) return;

    var token = ++swapToken;
    if (reduceMotion) {
      main.setAttribute('src', full);
      if (alt != null) main.setAttribute('alt', alt);
      return;
    }
    var pre = new Image();
    pre.src = full;
    var ready = pre.decode
      ? pre.decode().catch(function () {})
      : new Promise(function (res) { pre.onload = res; pre.onerror = res; });
    ready.then(function () {
      if (token !== swapToken) return; // a later hover superseded this one
      var layer = xfadeLayer(main);
      // if a dissolve is mid-flight, commit its frame beneath before retargeting
      if (layer.classList.contains('is-in') && layer.getAttribute('src')) {
        main.setAttribute('src', layer.getAttribute('src'));
      }
      layer.setAttribute('src', full);
      layer.classList.remove('is-in');
      void layer.offsetWidth;
      layer.classList.add('is-in');
      var done = function (e) {
        if (e.propertyName !== 'opacity') return;
        layer.removeEventListener('transitionend', done);
        if (token !== swapToken) return;
        main.setAttribute('src', full);
        if (alt != null) main.setAttribute('alt', alt);
        layer.classList.remove('is-in'); // invisible: main now holds the same frame
      };
      layer.addEventListener('transitionend', done);
    });
  }

  function step(dir) {
    var list = thumbs();
    if (!list.length) return;
    var i = list.findIndex(function (x) { return x.classList.contains('is-active'); });
    show(list[(i + dir + list.length) % list.length]);
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest ? e.target.closest('[data-gallery-thumb],[data-gallery-prev],[data-gallery-next]') : null;
    if (!c) return;
    e.preventDefault();
    if (c.hasAttribute('data-gallery-prev')) step(-1);
    else if (c.hasAttribute('data-gallery-next')) step(1);
    else show(c);
  });

  // hover previews without requiring a click (no-op on touch devices)
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest ? e.target.closest('[data-gallery-thumb]') : null;
    if (t && !t.classList.contains('is-active')) show(t);
  });


  document.addEventListener('keydown', function (e) {
    if (!document.querySelector('[data-gallery-main]')) return;
    if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
    if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
})();
